import { render } from "./DocViewNoOp.vue?vue&type=template&id=223b8cd3&scoped=true"
import script from "./DocViewNoOp.vue?vue&type=script&lang=js"
export * from "./DocViewNoOp.vue?vue&type=script&lang=js"

import "./DocViewNoOp.vue?vue&type=style&index=0&id=223b8cd3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223b8cd3"]])

export default __exports__